import type { ApiProxyClient } from '../../types';
import { getProductRecommendations } from './getProductRecommendations';

export const recommendationsApi: ApiProxyClient['recommendations'] = {
    getProductRecommendations,
};
